import RSSButtonComponent from '@wix/thunderbolt-elements/src/components/RSSButton/viewer/RSSButton';
import RSSButtonController from '@wix/thunderbolt-elements/src/components/RSSButton/viewer/RSSButton.controller';


const RSSButton = {
  component: RSSButtonComponent,
  controller: RSSButtonController
};


export const components = {
  ['RSSButton']: RSSButton
};

